import { Injectable } from '@angular/core';

import { BaseService } from '../../_services/base.service';
import { BuyerDadosPedidoService } from '../_componentes/dados-pedido/dados-pedido.service';

@Injectable({ providedIn: 'root' })
export class BuyerVisaoGeralDetalheService extends BaseService
{
    constructor(private dadosPedidoService: BuyerDadosPedidoService) { super(); }

    public get(quotation_id: number) {
        return this.dadosPedidoService.get(quotation_id);
    }
}
